'use client'
import { createContext, ReactNode } from 'react'

type ContextType = {
  onClose: () => void
  setModalBody: (body: ReactNode) => void
  modalBody: ReactNode | null
}
export const ModalContext = createContext<ContextType>({
  onClose: () => {
    // no-op
  },
  setModalBody: () => null,
  modalBody: null,
})
